import { ITranslations } from 'types/common';
import { ParsersTableTransFields } from './types';
import en from 'translations/en/parsersTable.json';
import pl from 'translations/pl/parsersTable.json';
import sl from 'translations/sl/parsersTable.json';

export const parsersTableTranslations: ITranslations<ParsersTableTransFields> = {
  name: 'parsersTable',
  en,
  pl,
  sl,
};
